module.exports = __webpack_public_path__ + "static/img/yxy-logo-green.0b4d7064310c980426dc215109440c70.png";